import React from "react";
import { makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import styleConstants from "../../../../styleConstants";
import "./sector.scss";

const useStyles = makeStyles(theme => ({
  label: {
    // fontSize: "0.875rem",
    fontSize: "14px",
    fill: "#000000"
  },
  emphasis: {
    fontWeight: styleConstants.fontWeights.bold
  }
}));

const Labels = props => {
  const classes = useStyles();

  const popUpAGroups = ["node8"];
  const popUpBGroups = ["node11", "node12"];

  return (
    <g>
      <text className={classes.label} transform="translate(14.7881 167.7334)">
        <tspan x="0" y="0">
          Who{" "}
        </tspan>
        <tspan className={classes.emphasis} x="29" y="0">
          funded{" "}
        </tspan>
        <tspan x="-9.7" y="14.2">
          the commodity?
        </tspan>
      </text>
      <text className={classes.label} transform="translate(273.0371 167.7334)">
        <tspan x="0" y="0">
          Who{" "}
        </tspan>
        <tspan className={classes.emphasis} x="29" y="0">
          procured{" "}
        </tspan>
        <tspan x="-3.4" y="14.2">
          the commodity?
        </tspan>
      </text>
      <text className={classes.label} transform="translate(496.6816 166.7275)">
        <tspan x="0" y="0">
          Who{" "}
        </tspan>
        <tspan className={classes.emphasis} x="29" y="0">
          distributed{" "}
        </tspan>
        <tspan x="3" y="14.2">
          the commodity?
        </tspan>
      </text>
      <text className={classes.label} transform="translate(825.2695 117.4556)">
        <tspan x="0" y="0">
          Where did the client{" "}
        </tspan>
        <tspan className={classes.emphasis} x="-11.8" y="14.2">
          receive{" "}
        </tspan>
        <tspan x="36.1" y="14.2">
          the commodity?
        </tspan>
      </text>
      <text
        className={classnames(
          "pop-up",
          popUpAGroups.includes(props.current) ? "active" : "faded"
        )}
        transform="translate(476.1382 77.2339)"
      >
        <tspan x="0" y="0">
          NGOs/SMOs have a wide{" "}
        </tspan>
        <tspan x="7" y="14.2">
          {" "}
          range of delivery and{" "}
        </tspan>
        <tspan x="10.5" y="28.3">
          distribution models.
        </tspan>
      </text>
      <text
        className={classnames(
          "pop-up",
          popUpBGroups.includes(props.current) ? "active" : "faded"
        )}
        transform="translate(836.5781 13.3818)"
      >
        <tspan x="0" y="0">
          Commodities from{" "}
        </tspan>
        <tspan x="-5.8" y="14.2">
          private facilities may{" "}
        </tspan>
        <tspan x="-1.5" y="28.3">
          be free, subsidized,{" "}
        </tspan>
        <tspan x="2" y="42.5">
          or non-subsidized.
        </tspan>
      </text>
    </g>
  );
};

export default Labels;
